import React, { FC, useRef, useState } from 'react'
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player'
import 'react-h5-audio-player/src/styles.scss'
import { BsPauseBtn, BsPlayBtn } from 'react-icons/bs'
import './customAudioPlayer.scss'

interface AudioPlayerProps {
  audioSrc?: string
  showSpeedBar?: boolean
}

const CustomAudioPlayer: FC<AudioPlayerProps> = ({
  audioSrc = null,
  showSpeedBar = true,
}) => {
  const playerRef = useRef<AudioPlayer>(null)
  const [playbackRate, setPlaybackRate] = useState(1.0)

  const handleRateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rate = parseFloat(e.target.value)
    console.log('Playback Rate Change:', rate)
    if (playerRef.current && playerRef.current.audio.current) {
      playerRef.current.audio.current.playbackRate = rate
    }
    setPlaybackRate(rate)
  }

  return (
    <>
      {!!audioSrc && (
        <>
          <h6 className="fw-bold">Audio</h6>
          <AudioPlayer
            ref={playerRef}
            src={audioSrc}
            showJumpControls={false}
            className=""
            layout="horizontal-reverse"
            customControlsSection={[RHAP_UI.MAIN_CONTROLS]}
            customIcons={{
              play: <BsPlayBtn className="text-primary"></BsPlayBtn>,
              pause: <BsPauseBtn className="text-primary"></BsPauseBtn>,
            }}
          />
          {showSpeedBar && (
            <div className="d-flex mt-2">
              <span className="pe-2 fw-bold">{playbackRate}x</span>
              <input
                className="w-100"
                type="range"
                min="1.0"
                max="1.5"
                step="0.05"
                value={playbackRate}
                onChange={handleRateChange}
              />
            </div>
          )}
        </>
      )}
      {!audioSrc && <h6 className="fw-bold">Audio nemá žádný zdroj</h6>}
    </>
  )
}

export default CustomAudioPlayer
